/* eslint-disable import/prefer-default-export */
import React from "react";
import { Box, Tab, Tabs } from "@mui/material";

import Panel from "../../../../components/Panel";
import SettingsButton from "../../../../components/SettingsButton/SettingsButton";
import { GeneralIpdSettings } from "./GeneralIpdSettings";
import { RoomList } from "./RoomSettings/RoomList";
import { BedList } from "./BedSettings/BedList";
import { WardList } from "./WardSettings/WardList";

const TABS = {
  GENERAL_SETTINGS: "general_settings",
  WARD_SETTINGS: "ward_settings",
  ROOM_SETTINGS: "room_settings",
  BED_SETTINGS: "bed_settings"
};

interface Props {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  renderSettingButton?: boolean;
}

export const IpdSettingsPanel = ({
  open,
  onOpenChange,
  renderSettingButton = true
}: Props): React.ReactNode => {
  const [selectedTab, setSelectedTab] = React.useState(TABS.GENERAL_SETTINGS);
  const [internalOpen, setInternalOpen] = React.useState(false);

  const isControlled = typeof open === "boolean";
  const actualOpen = isControlled ? open : internalOpen;

  const setOpen = (value: boolean): void => {
    if (isControlled) {
      onOpenChange?.(value);
    } else {
      setInternalOpen(value);
    }
  };

  return (
    <>
      {renderSettingButton && <SettingsButton onClick={() => setOpen(!actualOpen)} />}

      {actualOpen && (
        <Panel
          onClose={() => setOpen(false)}
          title="IPD Settings"
          contentStyle={{
            height: "calc(100vh - 50px)",
            py: 0
          }}
          wrapperStyle={{
            width: "800px",
            maxWidth: "calc(100vw - 80px)"
          }}
        >
          <Box
            sx={{
              height: "100%",
              borderLeft: 1,
              borderRight: 1,
              borderColor: "divider",
              display: "flex",
              flexDirection: "column"
            }}
          >
            <Tabs
              value={selectedTab}
              onChange={(_, newValue) => setSelectedTab(newValue)}
              sx={{
                height: "50px",
                borderBottom: 1,
                borderColor: "divider"
              }}
            >
              <Tab label="General Settings" value={TABS.GENERAL_SETTINGS} />
              <Tab label="Ward Settings" value={TABS.WARD_SETTINGS} />
              <Tab label="Room Settings" value={TABS.ROOM_SETTINGS} />
              <Tab label="Bed Settings" value={TABS.BED_SETTINGS} />
            </Tabs>

            <Box sx={{ flexGrow: 1, overflow: "auto" }}>
              {selectedTab === TABS.GENERAL_SETTINGS && <GeneralIpdSettings />}
              {selectedTab === TABS.WARD_SETTINGS && <WardList />}
              {selectedTab === TABS.ROOM_SETTINGS && <RoomList />}
              {selectedTab === TABS.BED_SETTINGS && <BedList />}
            </Box>
          </Box>
        </Panel>
      )}
    </>
  );
};
